import { useMatches } from 'react-router';

import type { CmsApiPage } from '#/modules/cms/api/types/CmsApiPage';
import { cmsRouteId } from '#/modules/cms/routing/Cms.horizon-route';
import type { CmsPageLoaderData } from '#/modules/cms/routing/CmsPageLoaderData';

export function useRouteIsCmsApiPage(): CmsApiPage | undefined {
  const matches = useMatches();
  const lastMatch = matches[matches.length - 1];

  if (lastMatch.id !== cmsRouteId) return;

  const loaderData = lastMatch.data as CmsPageLoaderData;
  if (loaderData?.type !== 'CONTENT') return;

  return loaderData.content;
}
